import { render, staticRenderFns } from "./LtiView.vue?vue&type=template&id=61b49f80"
import script from "./LtiView.vue?vue&type=script&lang=js"
export * from "./LtiView.vue?vue&type=script&lang=js"
import style0 from "./LtiView.vue?vue&type=style&index=0&id=61b49f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports